(function () {
  'use strict';

  if (window.WGSReferralApp) {
    window.WGSReferralApp.init();
    return;
  }

  const app = {
    profilePromise: null,

    init: function () {
      document
        .querySelectorAll('[data-wgs-referral-root]')
        .forEach(function (root) {
          app.initRoot(root);
        });
    },

    initRoot: function (root) {
      if (root.dataset.wgsInitialized === 'true') {
        return;
      }

      root.dataset.wgsInitialized = 'true';

      app.bind(root);

      const module = root.dataset.wgsModule;

      if (module === 'share' || module === 'dashboard') {
        app.load(root, module);
      }
    },

    profile: function () {
      if (!window.WGSReferralService) {
        return Promise.reject(new Error('Referral service missing.'));
      }

      if (!app.profilePromise) {
        app.profilePromise = window.WGSReferralService
          .getProfile()
          .catch(function (error) {
            app.profilePromise = null;
            throw error;
          });
      }

      return app.profilePromise;
    },

    load: async function (root, module) {
      try {
        const profile = await app.profile();

        if (module === 'share') {
          app.renderShare(root, profile);
        }

        if (module === 'dashboard') {
          app.renderDashboard(root, profile);
        }
      } catch (error) {
        console.warn('[WGS Referral]', error);
        app.renderFailure(root, module);
      }
    },

    renderShare: function (root, profile) {
      app.hide(root, '[data-wgs-share-loading]');

      if (!profile.hasReferralUrl) {
        app.show(root, '[data-wgs-share-fallback]');
        return;
      }

      root.dataset.wgsReferralUrl = profile.referralUrl;

      const field = root.querySelector('[data-wgs-referral-link]');

      if (field) {
        field.value = profile.referralUrl;
      }

      app.buildChannels(root);
      app.show(root, '[data-wgs-share-content]');
    },

    renderDashboard: function (root, profile) {
      app.text(
        root,
        '[data-wgs-value="available"]',
        app.money(profile.available, root)
      );

      app.text(
        root,
        '[data-wgs-value="pending"]',
        app.money(profile.pending, root)
      );

      app.text(
        root,
        '[data-wgs-value="lifetime"]',
        app.money(profile.lifetime, root)
      );

      app.hide(root, '[data-wgs-dashboard-loading]');
      app.show(root, '[data-wgs-dashboard-content]');
    },

    renderFailure: function (root, module) {
      if (module === 'share') {
        app.hide(root, '[data-wgs-share-loading]');
        app.hide(root, '[data-wgs-share-content]');
        app.show(root, '[data-wgs-share-fallback]');
      }

      if (module === 'dashboard') {
        app.hide(root, '[data-wgs-dashboard-loading]');
        app.hide(root, '[data-wgs-dashboard-content]');
        app.show(root, '[data-wgs-dashboard-error]');
      }
    },

    bind: function (root) {
      root.addEventListener('click', function (event) {
        const trigger = event.target.closest('[data-wgs-action]');

        if (!trigger) {
          return;
        }

        const action = trigger.dataset.wgsAction;

        if (action === 'copy') {
          event.preventDefault();
          app.copyBrand(root);
        }

        if (action === 'native-share') {
          event.preventDefault();
          app.shareBrand(root);
        }

        if (action === 'share-product') {
          event.preventDefault();
          app.shareProduct(root, trigger);
        }

        if (action === 'portal') {
          event.preventDefault();
          app.portal(root);
        }
      });
    },

    brandMessage: function (root) {
      const url = root.dataset.wgsReferralUrl || '';
      const template = root.dataset.wgsShareMessage || '{url}';

      return template.indexOf('{url}') >= 0
        ? template.replace(/\{url\}/g, url)
        : (template + ' ' + url).trim();
    },

    buildChannels: function (root) {
      const message = app.brandMessage(root);
      const subject = root.dataset.wgsShareSubject || '';

      const email = root.querySelector('[data-wgs-share-email]');
      const whatsapp = root.querySelector('[data-wgs-share-whatsapp]');

      if (email) {
        email.href =
          'mailto:?subject=' +
          encodeURIComponent(subject) +
          '&body=' +
          encodeURIComponent(message);
      }

      if (whatsapp) {
        whatsapp.href =
          'https://wa.me/?text=' +
          encodeURIComponent(message);
      }
    },

    copyBrand: async function (root) {
      const url = root.dataset.wgsReferralUrl;

      if (!url) {
        return;
      }

      try {
        await app.copy(url);

        const success =
          root.dataset.wgsCopySuccess ||
          'Referral link copied.';

        app.feedback(root, success);

        const label = root.querySelector('[data-wgs-copy-label]');

        if (label) {
          label.textContent = success;

          window.setTimeout(function () {
            label.textContent =
              root.dataset.wgsCopyLabel ||
              'Copy Link';
          }, 2000);
        }
      } catch (error) {
        app.feedback(
          root,
          root.dataset.wgsCopyFailure ||
          'Copy failed.'
        );
      }
    },

    shareBrand: async function (root) {
      const url = root.dataset.wgsReferralUrl;

      if (!url) {
        return;
      }

      const full = app.brandMessage(root);
      const text = full.replace(url, '').trim();

      if (navigator.share) {
        try {
          await navigator.share({
            title: root.dataset.wgsShareSubject || 'movozio',
            text: text,
            url: url
          });

          return;
        } catch (error) {
          if (error && error.name === 'AbortError') {
            return;
          }
        }
      }

      app.copyBrand(root);
    },

    shareProduct: async function (root, trigger) {
      const card = trigger.closest('[data-wgs-product]');

      if (!card) {
        return;
      }

      try {
        const profile = await app.profile();

        if (!profile.hasReferralUrl) {
          app.productFeedback(
            root,
            root.dataset.wgsNoLink ||
            'Your referral link is unavailable.'
          );
          return;
        }

        const deepLink = window.WGSReferralService.createDeepLink(
          card.dataset.wgsProductUrl,
          profile.referralUrl
        );

        if (!deepLink) {
          throw new Error('Could not build product referral link.');
        }

        const product = card.dataset.wgsProductTitle || 'movozio product';

        let message =
          root.dataset.wgsProductMessage ||
          '{product}: {url}';

        message = message
          .replace(/\{product\}/g, product)
          .replace(/\{url\}/g, deepLink);

        if (navigator.share) {
          try {
            await navigator.share({
              title:
                root.dataset.wgsProductSubject ||
                product,
              text: message.replace(deepLink, '').trim(),
              url: deepLink
            });

            return;
          } catch (error) {
            if (error && error.name === 'AbortError') {
              return;
            }
          }
        }

        await app.copy(deepLink);

        app.productFeedback(
          root,
          root.dataset.wgsCopySuccess ||
          'Product referral link copied.'
        );
      } catch (error) {
        console.warn('[WGS Product Referral]', error);

        app.productFeedback(
          root,
          root.dataset.wgsCopyFailure ||
          'Product sharing is temporarily unavailable.'
        );
      }
    },

    copy: async function (text) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const field = document.createElement('textarea');

      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';

      document.body.appendChild(field);

      field.select();
      field.setSelectionRange(0, field.value.length);

      const success = document.execCommand('copy');

      document.body.removeChild(field);

      if (!success) {
        throw new Error('Clipboard unavailable.');
      }
    },

    portal: function (root) {
      const url = root.dataset.wgsPortalUrl;

      if (url) {
        window.location.href = url;
      }
    },

    money: function (value, root) {
      const currency = root.dataset.wgsCurrency || 'USD';

      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency
        }).format(Number(value) || 0);
      } catch (error) {
        return (Number(value) || 0).toFixed(2);
      }
    },

    feedback: function (root, message) {
      const el = root.querySelector('[data-wgs-share-feedback]');

      if (!el) {
        return;
      }

      el.textContent = message;

      window.setTimeout(function () {
        if (el.textContent === message) {
          el.textContent = '';
        }
      }, 3000);
    },

    productFeedback: function (root, message) {
      const el = root.querySelector('[data-wgs-product-feedback]');

      if (!el) {
        return;
      }

      el.textContent = message;

      window.setTimeout(function () {
        if (el.textContent === message) {
          el.textContent = '';
        }
      }, 3000);
    },

    text: function (root, selector, value) {
      const el = root.querySelector(selector);

      if (el) {
        el.textContent = value;
      }
    },

    show: function (root, selector) {
      const el = root.querySelector(selector);

      if (el) {
        el.hidden = false;
      }
    },

    hide: function (root, selector) {
      const el = root.querySelector(selector);

      if (el) {
        el.hidden = true;
      }
    }
  };

  window.WGSReferralApp = app;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', app.init);
  } else {
    app.init();
  }

  document.addEventListener('shopify:section:load', app.init);
})();